import { Fragment } from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { ICategoryProps } from './Category.model';
import {
	StyledContainer,
	StyledNameContainer,
	StyledPriceContainer,
} from './Category.styled';

const Category: React.FC<ICategoryProps & { onClick: () => void }> = ({
	name,
	type,
	price,
	icon,
	selected,
	notActive,
	onClick,
}: ICategoryProps & { onClick: () => void }) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer
			$selected={selected}
			$notActive={notActive}
			onClick={() => {
				if (!notActive) {
					onClick();
					playSound(Sound.ClickButton);
				}
			}}
			onMouseEnter={() => {
				if (!notActive) {
					playSound(Sound.LinkCursor);
				}
			}}
		>
			<img src={icon} width={30} height={30} />
			<StyledNameContainer>
				<Text>
					{name} <span>({type})</span>
				</Text>
			</StyledNameContainer>
			<StyledPriceContainer>
				{notActive ? (
					<Text>Получено</Text>
				) : (
					<Fragment>
						<CurrencyIcon icon={rubleIcon} size="md" />
						<Text>{price.toLocaleString('ru-ru')}</Text>
					</Fragment>
				)}
			</StyledPriceContainer>
		</StyledContainer>
	);
};

export { Category };
